const CheckAdminSVG = (): JSX.Element => {
  return (
    <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 6L5.54545 10L11 1" stroke="#00112F" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default CheckAdminSVG
